/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_SignalsInputs */

const en_directory_footer_link_signals = /** @type {(inputs: Directory_Footer_Link_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const zh_directory_footer_link_signals = /** @type {(inputs: Directory_Footer_Link_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基准评分`)
};

/**
* | output |
* | --- |
* | "Benchmarks" |
*
* @param {Directory_Footer_Link_SignalsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_signals = /** @type {((inputs?: Directory_Footer_Link_SignalsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_SignalsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_signals(inputs)
	return zh_directory_footer_link_signals(inputs)
});
export { directory_footer_link_signals as "directory.footer.link_signals" }